export interface Article {
  id: number;
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  excerpt: string;
  content: string;
  coverImage: string;
  author: string;
  authorAvatar: string;
  publishDate: string;
  heat: number;
  tags: string[];
  isHot: boolean;
}

export interface Category {
  name: string;
  slug: string;
  description: string;
  icon: string;
  coverImage: string;
}

export interface Comment {
  id: number;
  userName: string;
  userAvatar: string;
  content: string;
  likes: number;
  time: string;
  floor: number;
}

export interface EditorReview {
  rating: number;
  title: string;
  content: string;
  editorName: string;
  editorTitle: string;
  editorAvatar: string;
}

export const categories: Category[] = [
  {
    name: '明星塌房',
    slug: 'star-collapse',
    description: '明星艺人翻车塌房事件全记录，内幕深扒、实锤证据一网打尽，让你看清娱乐圈真实面目。',
    icon: 'ri-star-smile-line',
    coverImage: 'https://readdy.ai/api/search-image?query=Dramatic%20celebrity%20scandal%20atmosphere%20with%20paparazzi%20camera%20flashes%20and%20shattered%20spotlight%2C%20dark%20cinematic%20background%20with%20warm%20red%20and%20gold%20lighting%2C%20abstract%20broken%20fame%20symbol%2C%20editorial%20photography%20style%20with%20soft%20shadows%20and%20intense%20mood%2C%20mysterious%20celebrity%20silhouette%20in%20distance%2C%20high%20contrast%20dramatic%20composition&width=800&height=600&seq=cat-star-collapse&orientation=landscape',
  },
  {
    name: '网红翻车',
    slug: 'influencer-fail',
    description: '网红主播翻车实录，从带货造假到人设崩塌，全网最新翻车事件第一时间追踪报道。',
    icon: 'ri-live-line',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20influencer%20social%20media%20controversy%20scene%20with%20smartphone%20screens%20displaying%20dramatic%20notifications%20and%20broken%20verified%20badges%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20abstract%20digital%20chaos%20background%2C%20editorial%20composition%20with%20soft%20bokeh%20lighting%2C%20mysterious%20tech-noir%20atmosphere%2C%20high%20detail%20cinematic%20quality&width=800&height=600&seq=cat-influencer-fail&orientation=landscape',
  },
  {
    name: '综艺深扒',
    slug: 'variety-deep',
    description: '热门综艺节目幕后真相大揭秘，选手内幕、剪辑套路、制作黑幕，让你看懂综艺的台前幕后。',
    icon: 'ri-tv-line',
    coverImage: 'https://readdy.ai/api/search-image?query=Reality%20TV%20show%20behind%20the%20scenes%20dramatic%20production%20set%20with%20bright%20studio%20lights%20and%20cameras%2C%20warm%20gold%20and%20deep%20crimson%20tones%2C%20abstract%20television%20production%20atmosphere%2C%20editorial%20photography%20with%20soft%20focus%20background%2C%20mysterious%20backstage%20mood%2C%20cinematic%20composition%20with%20dramatic%20lighting%20contrast&width=800&height=600&seq=cat-variety-deep&orientation=landscape',
  },
];

export const articles: Article[] = [
  {
    id: 1,
    title: '某顶流男星深夜密会神秘女子，酒店共处8小时后凌晨分别离开',
    slug: 'top-star-secret-date-hotel',
    category: '明星塌房',
    categorySlug: 'star-collapse',
    excerpt: '据知情人士爆料，某当红顶流男星近日被拍到深夜与一位神秘女子在某五星级酒店密会，两人一前一后进入酒店，共处长达八小时后于凌晨分别离开。该男星此前一直以单身人设示人，此番爆料或将引发粉丝大地震。',
    content: '',
    coverImage: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20entrance%20at%20night%20with%20dramatic%20paparazzi%20style%20lighting%20and%20mysterious%20atmosphere%2C%20warm%20red%20and%20amber%20tones%2C%20abstract%20celebrity%20silhouette%20walking%20through%20hotel%20lobby%2C%20cinematic%20editorial%20photography%20with%20soft%20bokeh%20and%20deep%20shadows%2C%20high%20contrast%20dramatic%20composition%20with%20tension%20and%20suspense%2C%20golden%20hour%20meets%20midnight%20noir%20aesthetic&width=800&height=500&seq=article-1-cover&orientation=landscape',
    author: '吃瓜小分队',
    authorAvatar: '',
    publishDate: '2026-07-06',
    heat: 98500,
    tags: ['顶流男星', '恋情曝光', '酒店密会', '人设崩塌'],
    isHot: true,
  },
  {
    id: 2,
    title: '千万粉丝网红直播带货翻车！自称"纯天然"产品被实锤含违禁成分',
    slug: 'influencer-livestream-fake-product',
    category: '网红翻车',
    categorySlug: 'influencer-fail',
    excerpt: '拥有超过2000万粉丝的头部带货主播"XX姐"近日遭遇最大信任危机。其直播间力推的"纯天然植物萃取"护肤品被第三方检测机构实锤含有激素类违禁成分，多名消费者使用后出现严重过敏反应。品牌方已紧急下架所有相关产品。',
    content: '',
    coverImage: 'https://readdy.ai/api/search-image?query=Dramatic%20livestream%20shopping%20scene%20with%20smartphone%20displaying%20warning%20notifications%20and%20broken%20trust%20symbols%2C%20beauty%20products%20scattered%20on%20dark%20surface%2C%20warm%20amber%20and%20crimson%20tones%2C%20abstract%20social%20media%20crisis%20atmosphere%2C%20editorial%20photography%20with%20soft%20dramatic%20lighting%20and%20deep%20shadows%2C%20intense%20documentary%20style%20composition&width=800&height=500&seq=article-2-cover&orientation=landscape',
    author: '实锤调查局',
    authorAvatar: '',
    publishDate: '2026-07-05',
    heat: 126800,
    tags: ['带货翻车', '违禁成分', '消费者维权', '信任危机'],
    isHot: true,
  },
  {
    id: 3,
    title: '某选秀节目导演组内部聊天记录外泄：选手排名早已内定',
    slug: 'talent-show-ranking-rigged',
    category: '综艺深扒',
    categorySlug: 'variety-deep',
    excerpt: '一则据称来自某热门选秀节目导演组的工作群聊天记录近日在网络上疯传。聊天内容显示，节目组早在录制前就确定了最终排名名单，所谓的"观众投票"不过是走过场。涉及多位知名练习生，网友直呼"塌房了"。',
    content: '',
    coverImage: 'https://readdy.ai/api/search-image?query=Talent%20show%20stage%20with%20dramatic%20spotlight%20and%20leaked%20document%20papers%20scattered%20on%20floor%2C%20warm%20gold%20and%20deep%20red%20theatrical%20lighting%2C%20abstract%20reality%20TV%20controversy%20atmosphere%2C%20editorial%20photography%20with%20soft%20focus%20and%20dramatic%20shadows%2C%20cinematic%20composition%20with%20tension%20and%20mystery%2C%20behind%20the%20scenes%20documentary%20style&width=800&height=500&seq=article-3-cover&orientation=landscape',
    author: '综艺扒姐',
    authorAvatar: '',
    publishDate: '2026-07-05',
    heat: 87300,
    tags: ['选秀黑幕', '内定排名', '聊天记录', '节目造假'],
    isHot: true,
  },
  {
    id: 4,
    title: '知名女星被曝税务问题，工作室紧急发声明否认，网友扒出更多细节',
    slug: 'actress-tax-scandal-details',
    category: '明星塌房',
    categorySlug: 'star-collapse',
    excerpt: '继多位明星因税务问题翻车后，又一位知名女星被曝出存在严重税务问题。虽然工作室火速发布声明否认，但细心的网友已经从公开信息中扒出多个疑点，涉及金额或超千万。相关部门是否已介入调查引发关注。',
    content: '',
    coverImage: 'https://readdy.ai/api/search-image?query=Celebrity%20financial%20scandal%20atmosphere%20with%20tax%20documents%20and%20investigation%20files%20on%20dark%20wooden%20desk%2C%20warm%20dramatic%20red%20and%20gold%20lighting%2C%20abstract%20legal%20controversy%20mood%2C%20editorial%20photography%20with%20deep%20shadows%20and%20soft%20highlights%2C%20cinematic%20composition%20with%20tension%20and%20mystery%2C%20high%20contrast%20documentary%20style&width=800&height=500&seq=article-4-cover&orientation=landscape',
    author: '税海吃瓜人',
    authorAvatar: '',
    publishDate: '2026-07-04',
    heat: 112400,
    tags: ['税务问题', '明星翻车', '声明否认', '细节深扒'],
    isHot: true,
  },
  {
    id: 5,
    title: 'B站百万UP主被前员工爆料：拖欠工资、PUA员工、抄袭同行内容',
    slug: 'bilibili-creator-toxic-workplace',
    category: '网红翻车',
    categorySlug: 'influencer-fail',
    excerpt: '一位自称曾在某B站百万粉丝UP主团队工作两年的前员工，在社交平台发布长文，详细揭露了该UP主拖欠员工工资、长期精神打压、以及大量抄袭海外创作者内容的黑料。该UP主目前尚未作出回应。',
    content: '',
    coverImage: 'https://readdy.ai/api/search-image?query=Creative%20studio%20workspace%20controversy%20scene%20with%20scattered%20papers%20and%20resignation%20letter%20on%20desk%2C%20warm%20amber%20and%20deep%20crimson%20tones%2C%20abstract%20workplace%20drama%20atmosphere%2C%20editorial%20photography%20with%20soft%20shadows%20and%20dramatic%20lighting%2C%20cinematic%20composition%20with%20tension%2C%20documentary%20style%20behind%20the%20scenes%20mood&width=800&height=500&seq=article-5-cover&orientation=landscape',
    author: '打工人联盟',
    authorAvatar: '',
    publishDate: '2026-07-04',
    heat: 76500,
    tags: ['UP主翻车', '拖欠工资', 'PUA', '内容抄袭'],
    isHot: false,
  },
  {
    id: 6,
    title: '某综艺嘉宾录制现场情绪失控罢录，导演组全员懵了，真相竟是...',
    slug: 'variety-guest-walk-off',
    category: '综艺深扒',
    categorySlug: 'variety-deep',
    excerpt: '据现场工作人员透露，某热门综艺在最新一期录制过程中突发意外——一位常驻嘉宾在游戏环节突然情绪失控，当场宣布退出录制并摔门离开。导演组全员懵圈，录制被迫中断近两小时。背后的故事远比表面看到的复杂。',
    content: '',
    coverImage: 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20dramatic%20empty%20chair%20under%20spotlight%20and%20abandoned%20microphone%2C%20warm%20gold%20and%20crimson%20theatrical%20lighting%2C%20abstract%20variety%20show%20drama%20atmosphere%2C%20editorial%20photography%20with%20soft%20focus%20and%20dramatic%20shadows%2C%20cinematic%20composition%20with%20tension%20and%20mystery%2C%20behind%20the%20scenes%20documentary%20mood&width=800&height=500&seq=article-6-cover&orientation=landscape',
    author: '录制现场线人',
    authorAvatar: '',
    publishDate: '2026-07-03',
    heat: 65400,
    tags: ['综艺录制', '嘉宾失控', '录制中断', '幕后故事'],
    isHot: false,
  },
  {
    id: 7,
    title: '某知名歌手演唱会假唱被实锤！现场观众晒出多段对比音频证据',
    slug: 'singer-lip-sync-exposed',
    category: '明星塌房',
    categorySlug: 'star-collapse',
    excerpt: '一位购买VIP前排票的粉丝在社交平台晒出多段现场录制音频与官方音源的专业对比分析，实锤某知名歌手在近期演唱会上存在严重假唱行为。"花了两千多买票，结果听的是CD"，该粉丝愤怒表示。',
    content: '',
    coverImage: 'https://readdy.ai/api/search-image?query=Concert%20stage%20with%20dramatic%20spotlight%20on%20empty%20microphone%20stand%20and%20audio%20waveform%20analysis%20display%2C%20warm%20red%20and%20deep%20amber%20theatrical%20lighting%2C%20abstract%20music%20controversy%20atmosphere%2C%20editorial%20photography%20with%20soft%20dramatic%20shadows%2C%20cinematic%20composition%20with%20tension%2C%20documentary%20style%20concert%20mood&width=800&height=500&seq=article-7-cover&orientation=landscape',
    author: '音轨鉴定师',
    authorAvatar: '',
    publishDate: '2026-07-03',
    heat: 89100,
    tags: ['假唱实锤', '演唱会', '音频对比', '粉丝维权'],
    isHot: true,
  },
  {
    id: 8,
    title: '某美食博主被曝后厨卫生堪忧，老鼠蟑螂齐上阵，网友：yue了',
    slug: 'food-blogger-kitchen-hygiene',
    category: '网红翻车',
    categorySlug: 'influencer-fail',
    excerpt: '以"精致厨房"人设走红的某美食博主，被前合作方曝光其拍摄场地的真实后厨环境。照片显示厨房卫生状况令人作呕——老鼠屎遍地、蟑螂乱爬、食材随意堆放。与其视频中光鲜亮丽的画面形成鲜明对比。',
    content: '',
    coverImage: 'https://readdy.ai/api/search-image?query=Dirty%20kitchen%20behind%20the%20scenes%20of%20food%20photography%20with%20dramatic%20contrast%20between%20beautiful%20food%20plating%20and%20messy%20counter%20space%2C%20warm%20amber%20and%20dark%20crimson%20tones%2C%20abstract%20food%20safety%20controversy%20atmosphere%2C%20editorial%20photography%20with%20dramatic%20shadows%2C%20cinematic%20documentary%20composition%2C%20gritty%20behind%20the%20scenes%20mood&width=800&height=500&seq=article-8-cover&orientation=landscape',
    author: '卫生监督员',
    authorAvatar: '',
    publishDate: '2026-07-02',
    heat: 103200,
    tags: ['美食博主', '卫生问题', '后厨曝光', '人设崩塌'],
    isHot: true,
  },
  {
    id: 9,
    title: '恋爱综艺CP私下关系曝光：台上甜蜜台下互删，节目组紧急公关',
    slug: 'dating-show-cp-fake',
    category: '综艺深扒',
    categorySlug: 'variety-deep',
    excerpt: '某档热播恋爱综艺中人气最高的一对CP，被网友发现节目播出期间私下早已互相取关并删除所有合照。知情人士爆料两人在节目结束后即闹掰，但节目组为了收视率仍在剪辑"甜蜜"画面。CP粉集体破防。',
    content: '',
    coverImage: 'https://readdy.ai/api/search-image?query=Dating%20reality%20show%20romantic%20set%20with%20dramatic%20broken%20heart%20symbolism%20and%20shattered%20rose%20petals%2C%20warm%20gold%20and%20deep%20crimson%20theatrical%20lighting%2C%20abstract%20love%20controversy%20atmosphere%2C%20editorial%20photography%20with%20soft%20dramatic%20shadows%2C%20cinematic%20composition%20with%20emotional%20tension%2C%20documentary%20style%20behind%20romance%20mood&width=800&height=500&seq=article-9-cover&orientation=landscape',
    author: 'CP打假办',
    authorAvatar: '',
    publishDate: '2026-07-02',
    heat: 94700,
    tags: ['恋综CP', '假营业', '取关互删', '节目剪辑'],
    isHot: false,
  },
];

export const comments: Comment[] = [
  {
    id: 1,
    userName: '吃瓜不嫌事大',
    userAvatar: '',
    content: '我的天！这也太劲爆了吧！果然娱乐圈没有不透风的墙，坐等更多实锤！',
    likes: 3280,
    time: '2小时前',
    floor: 1,
  },
  {
    id: 2,
    userName: '理智追星人',
    userAvatar: '',
    content: '建议大家先观望一下，不要急着站队。现在只有单方面爆料，等当事人回应了再说。不过如果属实的话，确实挺让人失望的。',
    likes: 1560,
    time: '1小时前',
    floor: 2,
  },
  {
    id: 3,
    userName: '八卦协会会长',
    userAvatar: '',
    content: '哈哈哈哈我就知道！之前看他的采访就觉得不太对劲，果然翻车了。内娱还有什么是真的？',
    likes: 2450,
    time: '45分钟前',
    floor: 3,
  },
  {
    id: 4,
    userName: '深夜吃瓜人',
    userAvatar: '',
    content: '刚从微博过来，热搜已经爆了！这个瓜越挖越大，据说还牵扯出好几个其他人，坐等后续。',
    likes: 1890,
    time: '30分钟前',
    floor: 4,
  },
  {
    id: 5,
    userName: '真相挖掘机',
    userAvatar: '',
    content: '我整理了时间线，其实这件事早有端倪。去年12月的那条微博、今年3月的采访、再加上这次的实锤，一切都对上了。',
    likes: 4120,
    time: '20分钟前',
    floor: 5,
  },
];

export const editorReview: EditorReview = {
  rating: 4.8,
  title: '主编锐评',
  content: '娱乐圈从来都是一场华丽的表演，有人演得好，有人演砸了。今天这个瓜之所以引发如此大的反响，不仅仅是因为当事人的知名度，更是因为这背后折射出的行业乱象——流量至上、人设横行、真伪难辨。在这个信息爆炸的时代，吃瓜不是目的，看清真相才是。我们51吃瓜爆料网始终坚持"吃瓜无罪，八卦有理"的理念，为你剥开娱乐圈的层层伪装，呈现最真实的八卦真相。',
  editorName: '大瓜主编',
  editorTitle: '51吃瓜爆料网 · 首席内容官',
  editorAvatar: '',
};

export const aboutInfo = {
  brandName: '51吃瓜爆料网',
  brandIntro: '51吃瓜爆料网成立于2020年，是国内领先的娱乐八卦资讯聚合平台。我们秉持"吃瓜无罪，八卦有理"的理念，致力于为广大网友提供最新、最快、最全的娱乐圈八卦资讯。从明星塌房到网红翻车，从综艺内幕到行业黑料，我们始终站在吃瓜第一线。',
  mission: '做最真实的娱乐八卦，让每一口瓜都有据可查',
  vision: '成为中文互联网最受信赖的娱乐资讯平台',
  values: ['真实客观', '快速响应', '深度挖掘', '趣味表达'],
  contactEmail: 'tips@51chigua.com',
  contactWechat: 'chigua51official',
  reputation: [
    {
      media: '新媒体观察',
      quote: '51吃瓜爆料网以其敏锐的娱乐嗅觉和扎实的调查功底，成为行业内不可忽视的八卦力量。',
      author: '媒体评论员 · 张老师',
    },
    {
      media: '互联网周刊',
      quote: '在娱乐资讯泛滥的今天，51吃瓜爆料网坚持用事实说话，用证据吃瓜，格局不一般。',
      author: '资深媒体人 · 李主编',
    },
    {
      media: '吃瓜群众',
      quote: '每天必刷！比其他八卦号靠谱多了，至少人家有图有真相，不是随便编个故事就发。',
      author: '忠实用户 · 小王同学',
    },
  ],
  faqs: [
    {
      question: '51吃瓜爆料网的内容来源是什么？',
      answer: '我们的内容来自多渠道信息整合，包括公开报道、社交媒体监测、行业线人爆料以及编辑团队的深度调查。所有爆料内容均经过多源交叉验证，确保信息的可靠性。',
    },
    {
      question: '如何向51吃瓜爆料网投稿爆料？',
      answer: '您可以通过发送邮件至 tips@51chigua.com 或关注微信公众号「chigua51official」进行投稿。我们承诺对爆料人信息严格保密，优质爆料还有丰厚奖励。',
    },
    {
      question: '遇到不实信息如何反馈？',
      answer: '如果您认为平台上的某条信息存在不实之处，请发送邮件至 tips@51chigua.com，附上相关证明材料。我们会在24小时内核实处理，情况属实的将立即更正或删除。',
    },
    {
      question: '51吃瓜爆料网会泄露用户隐私吗？',
      answer: '我们严格遵守相关法律法规，绝不会泄露用户的任何个人信息。浏览记录、评论内容等数据均采用加密存储，确保用户隐私安全。',
    },
  ],
};